import { lazy, Suspense } from "react";

const MapForward = lazy(() => import("../components/templates/home/MapForward.jsx"));
const ActiveFeed = lazy(() => import("../components/templates/home/ActiveFeed.jsx"));
const Infographic = lazy(() => import("../components/templates/home/Infographic.jsx"));
const SplitView = lazy(() => import("../components/templates/home/SplitView.jsx"));
const Dashboard = lazy(() => import("../components/templates/home/Dashboard.jsx"));
const Detail = lazy(() => import("../components/templates/home/Detail.jsx"));
const Gallery = lazy(() => import("../components/templates/home/Gallery.jsx"));
const Spotlight = lazy(() => import("../components/templates/home/Spotlight.jsx"));
const MapV2 = lazy(() => import("../components/templates/home/MapV2.jsx"));

/**
 * Template registry: maps template key to component.
 * Adding a new template only requires adding it here and creating the component.
 */
const TEMPLATES = {
  map: MapForward,
  active: ActiveFeed,
  infographic: Infographic,
  type: SplitView,
  dashboard: Dashboard,
  detail: Detail,
  gallery: Gallery,
  spotlight: Spotlight,
  mapv2: MapV2,
};

/** Templates currently enabled for production use. Others remain available via ?template= for dev. */
const ENABLED_TEMPLATES = new Set(["dashboard", "detail", "mapv2"]);

const DEFAULT_TEMPLATE = "dashboard";

/**
 * Resolves which template to render.
 * Priority: URL param ?template= (dev, any template) > templateOverride (system_pages, enabled only) > homepageTemplate (settings, enabled only) > default
 */
function resolveTemplate(templateOverride, homepageTemplate) {
  // URL param for dev/testing — allows ANY template
  const params = new URLSearchParams(window.location.search);
  const urlTemplate = params.get("template");
  if (urlTemplate && TEMPLATES[urlTemplate]) return urlTemplate;

  // system_pages override (DB-driven routing) — enabled only
  if (templateOverride && TEMPLATES[templateOverride] && ENABLED_TEMPLATES.has(templateOverride))
    return templateOverride;

  // Settings-backed selection — enabled only
  if (homepageTemplate && TEMPLATES[homepageTemplate] && ENABLED_TEMPLATES.has(homepageTemplate))
    return homepageTemplate;

  return DEFAULT_TEMPLATE;
}

export default function Home({ settings, statuses, categories, homepageTemplate, templateOverride }) {
  const templateKey = resolveTemplate(templateOverride, homepageTemplate);
  const TemplateComponent = TEMPLATES[templateKey];

  return (
    <Suspense fallback={null}>
      <TemplateComponent
        settings={settings}
        statuses={statuses}
        categories={categories}
      />
    </Suspense>
  );
}
